module.exports = __webpack_public_path__ + "static/media/1.6515149a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/products/images/21-006/1.jpg
// module id = 627
// module chunks = 0